export default function FavoriteGames() {
  const games = [
    {
      name: 'Adopt Me!',
      image: 'https://public.readdy.ai/ai/img_res/9907c5672edd30de28ab6460adf74281.jpg',
      hours: 342,
      visits: 1247,
    },
    {
      name: 'Brookhaven',
      image: 'https://readdy.ai/api/search-image?query=Brookhaven%20Roblox%20modern%20suburban%20neighborhood%20roleplay%20city%20houses%20streets%20realistic%20town%20simulation%20peaceful%20community&width=400&height=300&seq=brookhaven-game-img-v3&orientation=landscape',
      hours: 256,
      visits: 892,
    },
    {
      name: 'Tower of Hell',
      image: 'https://readdy.ai/api/search-image?query=Tower%20of%20Hell%20Roblox%20challenging%20obstacle%20course%20colorful%20platforms%20parkour%20vertical%20climbing%20dynamic%20action&width=400&height=300&seq=towerofhell-game-img-v3&orientation=landscape',
      hours: 189,
      visits: 634,
    },
  ];

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
      {/* Section Header */}
      <div className="text-center mb-12 sm:mb-16">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 px-2">
          Ваши любимые игры
        </h2>
        <div className="w-24 sm:w-32 h-1 bg-gradient-to-r from-[#00d4ff] to-[#a855f7] mx-auto mb-4 sm:mb-6 rounded-full" />
        <p className="text-base sm:text-lg md:text-xl text-white/60 max-w-2xl mx-auto px-4">
          Мы собрали игры, в которые вы чаще всего заходили в 2025 году.
        </p>
      </div>

      {/* Games Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
        {games.map((game, index) => (
          <div
            key={index}
            className="group bg-white/5 border border-white/10 rounded-2xl sm:rounded-3xl overflow-hidden hover:-translate-y-2 hover:border-[#00d4ff]/50 hover:shadow-[0_0_40px_rgba(0,212,255,0.2)] transition-all duration-300 cursor-pointer"
          >
            {/* Game Image */}
            <div className="relative w-full h-40 sm:h-48 overflow-hidden">
              <img
                src={game.image}
                alt={game.name}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e27] via-transparent to-transparent" />
            </div>

            {/* Game Info */}
            <div className="p-4 sm:p-6">
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">{game.name}</h3>
              
              <div className="grid grid-cols-2 gap-3 sm:gap-4">
                <div className="flex items-center gap-2">
                  <i className="ri-time-line text-[#00d4ff] text-base sm:text-lg w-5 h-5 flex items-center justify-center"></i>
                  <div>
                    <p className="text-xs sm:text-sm text-white/50">Часов</p>
                    <p className="text-base sm:text-lg font-semibold text-white/80">{game.hours}</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-2">
                  <i className="ri-game-line text-[#00d4ff] text-base sm:text-lg w-5 h-5 flex items-center justify-center"></i>
                  <div>
                    <p className="text-xs sm:text-sm text-white/50">Заходов</p>
                    <p className="text-base sm:text-lg font-semibold text-white/80">{game.visits}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
